import styled from "styled-components";

const Button = ({ className, style, type='default', size, round, disabled=false, onClick, children  }) => {
  return (
    <StyledButton
      style={style}
      className={className}
      type={type}
      size={size}
      round={round}
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
    >
      {children}
    </StyledButton>
  );
};

export default Button;

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: ${({ type }) => (type === 'text' || type === 'icon' ? 0 : '0 30px')};
  min-width: ${({ size, type }) => (size === 'small' ? '45px' : type === 'text' ? 0 :  type === 'icon' ? '60px' : 'auto')};
  height: ${({ size, type }) => (size === 'small' ? '45px' : type === 'text' ? 'auto' : '60px')};
  min-height: ${({ size, type }) => (size === 'small' ? '45px' : type === 'text' ? 'auto' : '60px')};
  max-height: ${({ size, type }) => (size === 'small' ? '45px' : type === 'text' ? 'auto' : '60px')};
  background: ${({ disabled, type }) => (disabled ? '#DCDCDC' : type === 'primary' ? '#EA394B' : type === 'text' ? 'none' : '#ebebeb')};
  border-radius: ${({ size, type, round }) => (size === 'small' ? '16px' : type === 'text' ? 0 : round ? '100px' : '20px')};
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  color: ${({ disabled, type }) => (disabled ? '#AAAAAA' : type === 'primary' ? '#FFFFFF' : type === 'text' ? undefined :'#2C2E32')};
  text-align: center;
  text-wrap: nowrap;
  transition: all 0.2s ease;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border: none;

  &:hover {
    background: ${({ type, disabled }) => {
      if (disabled) return;
      return type === 'primary' ? '#EB273B' : type === 'text' ? 'none' : '#E4E3E3';
    }};
    color: ${({ type, disabled }) => {
      if (disabled) return;
      return type === 'text' && '#EB273B';
    }};
  }

  &:active {
    background: ${({ type, disabled }) => {
      if (disabled) return;
      return type === 'primary' ? '#E01B2F' : type === 'text' ? 'none' : '#D9D8D8';
    }};
  }
  @media (max-width: 798px) {
    height: 45px;
    min-height: 45px;
    max-height: 45px;
    font-size: 16px;
    border-radius: 16px;
  }
`;